import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import LOGO from "@/assets/logo.png";

const TEL = "+36303915392";
const TEL_DISPLAY = "+36 30 391 5392";

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-32 md:py-44 lg:py-52 bg-anthracite-900 overflow-hidden border-t border-gold-500/15"
    >
      {/* Atmospheric layers */}
      <div className="absolute inset-0 hero-grain opacity-50" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-gold-500/[0.07] blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-burgundy-500/[0.08] blur-[120px] pointer-events-none" />

      {/* Floating logo watermark */}
      <motion.img
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 0.06, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2 }}
        src={LOGO}
        alt=""
        aria-hidden="true"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] max-w-none pointer-events-none"
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="flex items-center justify-center gap-4 mb-10">
            <div className="w-12 h-px bg-gold-500/60" />
            <span className="text-[10px] uppercase tracking-[0.5em] text-gold-500">
              Foglaljon időpontot
            </span>
            <div className="w-12 h-px bg-gold-500/60" />
          </div>

          <h2
            data-testid="final-cta-title"
            className="font-serif text-cream leading-[1.02] tracking-[-0.02em] font-light"
          >
            <span className="block text-4xl sm:text-5xl md:text-7xl lg:text-8xl">
              Készen áll a valódi
            </span>
            <span className="block text-4xl sm:text-5xl md:text-7xl lg:text-8xl italic gold-gradient-text mt-2">
              feltöltődésre?
            </span>
          </h2>

          <p className="mt-12 max-w-xl mx-auto text-cream/60 font-light text-base md:text-lg leading-relaxed">
            Hívjon bizalommal, és egyeztetünk egy Önnek megfelelő időpontot.
            <span className="block text-cream/40 mt-1 italic font-serif">Diszkréten, figyelmesen.</span>
          </p>

          <div className="mt-16 mb-12 relative">
            <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" />
            <motion.a
              href={`tel:${TEL}`}
              data-testid="final-cta-phone"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, delay: 0.2 }}
              className="relative inline-block bg-anthracite-900 px-4 sm:px-8 font-serif text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-light gold-gradient-text hover:opacity-90 transition-opacity tracking-wider"
            >
              {TEL_DISPLAY}
            </motion.a>
          </div>

          <motion.a
            href={`tel:${TEL}`}
            data-testid="final-cta-button"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.35 }}
            className="cta-button group inline-flex items-center justify-between gap-6 bg-gold-500 hover:bg-gold-400 text-anthracite-950 px-6 sm:px-10 py-4 sm:py-5 text-[10px] sm:text-xs uppercase tracking-[0.3em] font-medium transition-all w-full sm:w-auto sm:min-w-[300px] max-w-sm mx-auto"
          >
            <span>Időpontot egyeztetek</span>
            <Phone className="w-4 h-4 transition-transform group-hover:rotate-12 flex-shrink-0" strokeWidth={1.8} />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
